<template>
    <div>
        <transition name="fade" mode="out-in">
            <div v-if="systemStarted === null" class="loader">
                <loader-component size="lg"/>
            </div>
            <router-view v-else-if="systemStarted || $route.name === 'guardian'"/>
            <plug-component v-else/>
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import PlugComponent from "@/views/PlugComponent";
import LoaderComponent from "@/components/modules/LoaderComponent";

export default {
    name: 'App',
    components: {LoaderComponent, PlugComponent},
    data() {
        return {
            systemStarted: null,
            documents: {
                regulation: null,
                privacy_policy: null,
                // 'instrukcja-aplikacji-mobilnej': null,
                // 'instrukcja-platformy': null,
                // 'jak-aktywowac-karte': null,
                // 'jak-dodac-fv': null,
                // 'katalog-homologacji-pirelli': null,
                // 'lista-hurtowni': null,
                // 'lista-produktow': null,
                // 'oswiadczenie-pracownik': null,
                // 'szablon-excel-z-numerami-faktur': null,
            }
        }
    },
    computed:{
        isUserLoggedIn(){
            return this.$store.getters.isLoggedIn;
        }
    },
    provide() {
        return {
            documents: this.documents
        }
    },
    async beforeCreate() {
        await axios.get('/system-started')
            .then(response => {
                this.systemStarted = response.data;
            })
            .catch(() => {
                this.systemStarted = false
            });
        await this.getDocuments();
    },
    methods:{
        async getDocuments(){
            await window.api.get('/documents')
                .then(response => {
                    this.documents.regulation = response.data.data.find(d=>d.name==='regulamin');
                    this.documents.privacy_policy = response.data.data.find(d=>d.name==='polityka_prywatnosci');
                    response.data.data.forEach(doc => {
                        //It is needed to make documents elements reactive
                        this.$set(this.documents, doc.name, doc);
                        //this.documents[doc.name] = doc;
                    });
                    this.documents['regulations-historical'] = response.data.data.filter((d)=> {
                        if(d.name.startsWith('regulamin-') && d.is_historical){
                            return true
                        } else {
                            return false
                        }
                    });
                    // this.documents['instrukcja-aplikacji-mobilnej'] = response.data.data.find(d=>d.name==='instrukcja-aplikacji-mobilnej');
                    // this.documents['instrukcja-platformy'] = response.data.data.find(d=>d.name==='instrukcja-platformy');
                    // this.documents['jak-aktywowac-karte'] = response.data.data.find(d=>d.name==='jak-aktywowac-karte');
                    // this.documents['jak-dodac-fv'] = response.data.data.find(d=>d.name==='jak-dodac-fv');
                    // this.documents['katalog-homologacji-pirelli'] = response.data.data.find(d=>d.name==='katalog-homologacji-pirelli');
                    // this.documents['lista-hurtowni'] = response.data.data.find(d=>d.name==='lista-hurtowni');
                    // this.documents['lista-produktow'] = response.data.data.find(d=>d.name==='lista-produktow');
                    // this.documents['oswiadczenie-pracownik'] = response.data.data.find(d=>d.name==='oswiadczenie-pracownik');
                    // this.documents['szablon-excel-z-numerami-faktur'] = response.data.data.find(d=>d.name==='szablon-excel-z-numerami-faktur');
                })
                .catch(() => {

                });
        }
    },
    watch:{
        isUserLoggedIn(){
            this.getDocuments();
        }
    }
}
</script>

<style lang="scss">
@import "@/styles/app";

.loader {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
